/**
 * Filter bar for the Website Audit table.
 *
 * Layout: [Search input] [Rooftop ▾] [Condition ▾]
 *
 * Mirrors the inventory audit FilterBar pattern.
 */
import React from "react"

import { useWebsiteAudit } from "../../context/WebsiteAuditContext"
import { THEME } from "../../config/theme"
import MultiSelectDropdown from "../audit/MultiSelectDropdown"
import SearchInput from "../audit/SearchInput"

export default function WebsiteFilterBar() {
  const {
    filters,
    setFilter,
    search,
    setSearch,
    filterOptions,
    filterOptionsLoading,
  } = useWebsiteAudit()

  const containerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: THEME.spacing.sm,
    padding: `${THEME.spacing.sm} 0`,
    flexWrap: "wrap",
  }

  return (
    <div style={containerStyle}>
      <SearchInput
        value={search}
        onChange={setSearch}
        placeholder="Search VIN, stock, make, model, trim..."
      />
      <MultiSelectDropdown
        label="Rooftop"
        options={filterOptions?.rooftops ?? []}
        selected={filters.rooftop}
        onChange={(values) => setFilter("rooftop", values)}
        disabled={filterOptionsLoading}
      />
      <MultiSelectDropdown
        label="Condition"
        options={filterOptions?.vehicle_types ?? []}
        selected={filters.vehicle_type}
        onChange={(values) => setFilter("vehicle_type", values)}
        disabled={filterOptionsLoading}
        align="right"
      />
    </div>
  )
}
